import React from "react";
import "./FooterNew.css";

const FooterNew = () => {
  return (
    <footer className="footer_area">
      <div className="footer_copyright_area">
        <div className="container-footernew">
          <div className="col-md-12">
            <p className="tcenter">
              Copyright © Doctor Imtiaz Ahmed{" "}
              <span className="font-opensans">{new Date().getFullYear()}.</span>{" "}
              All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterNew;
